<template>
  <table style="table-layout:fixed;margin:0 auto;mso-table-lspace:0;mso-table-rspace:0" align="center" :bgcolor="color" border="0" cellpadding="0" cellspacing="0" width="100%">
    <tr>
      <td align="center" :bgcolor="color">
        <table class="table600Min" style="min-width:618px;mso-table-lspace:0pt;mso-table-rspace:0pt" align="center" :bgcolor="color" border="0" cellpadding="0" cellspacing="0" width="618">
          <tr>
            <td class="table600st" style="min-width:618px" align="left" width="618">
              <table class="table600Logo" style="mso-table-lspace:0pt;mso-table-rspace:0pt" align="center" border="0" cellpadding="0" cellspacing="0" width="230">
                <tr>
                  <td>
                    <table class="centerize" style="mso-table-lspace:0pt;mso-table-rspace:0pt" border="0" cellpadding="0" cellspacing="0">
                      <tr>
                        <td style="line-height:1px" align="center" valign="middle">
                          <a href="/?utm_source=sps-confirmation&utm_medium=email&utm_campaign=confirmation-email" target="_blank" style="text-decoration:none">
                            <img :src="logo" style="display:block;text-decoration:none;border:0" alt="Skyparksecure" width="245" height="60" hspace="0" align="top" border="0" vspace="0">
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'confirmation-view-header',
  props: {
    color: { type: String },
    logo: { type: String }
  }
}
</script>